var map = {
	"./horrorLogin1.webp": 28089,
	"./horrorLogin2.webp": 68700,
	"./horrorLogin3.webp": 75295,
	"./horrorLogin4.webp": 55714,
	"./horrorLogin5.webp": 27629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95836;